import { Link } from 'react-router-dom';
import { comics, latestComicIds } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const latestComics = latestComicIds.map((id) => comics.find((c) => c.id === id)!);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">每日新鲜上架，追更不等待</p>
          </div>
          <Link
            to="/category/latest"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-10 bg-background-50 rounded-lg p-6 md:p-8 flex flex-col lg:flex-row items-center gap-6">
          <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-notification-3-line text-2xl md:text-3xl text-primary-500"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-lg font-heading font-bold text-foreground-900">不想错过任何更新？</h3>
            <p className="text-sm text-foreground-500 mt-1">订阅我们的更新通知，第一时间获取最新韩漫上架信息</p>
          </div>
          <Link
            to="/category/latest"
            className="bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-2.5 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            查看最新
          </Link>
        </div>
      </div>
    </section>
  );
}